import styled from 'styled-components/macro';

export const HelpTileContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 200px;
  width: 350px;
  margin: 10px 5px;
  border-radius: 15px;
  border: 1px solid ${(p) => p.theme.palette.accentSecondary};
  background: ${(p) => p.theme.palette.backgroundSecondary};
`;

export const BaseItem = styled.div`
  display: flex;
  font-size: ${(p) => p.theme.sizes.xsmall};
  line-height: 16px;
`;

export const RowCenter = styled(BaseItem)`
  flex-direction: row;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
`;

export const Header = styled(BaseItem)`
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 64px;
  border-radius: 15px 15px 0 0;
  border-bottom: 1px solid ${(p) => p.theme.palette.accentSecondary};
  background: ${(p) => p.theme.palette.backgroundQuaternary};
`;

export const Types = styled(BaseItem)`
  width: max-content;
  margin-bottom: 0;
`;

export const Title = styled(BaseItem)`
  width: calc(100%);
  padding-right: 5px;
  color: ${(p) => p.theme.palette.accentSecondary};
  font-weight: bold;
  margin-bottom: 0;
  text-wrap: auto;
`;

export const DescriptionCenter = styled(BaseItem)`
  height: 130px;
  width: calc(100% - 20px);
  align-items: center;
`;

export const Description = styled(BaseItem)`
  text-align: center;
  color: ${(p) => p.theme.palette.textPrimary};
`;

export const Data = styled(BaseItem)`
  width: 100%;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  border-radius: 0 0 15px 15px;
  border-top: 1px solid ${(p) => p.theme.palette.accentSecondary};
  background: ${(p) => p.theme.palette.backgroundQuaternary};
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  min-width: 50px;
  font-size: ${(p) => p.theme.sizes.xsmall};
`;
